<template>
  <div
    class="d-flex gap-2 mt-1"
    :class="[isOneLine ? 'align-center' : 'flex-column']"
    v-bind="$attrs"
  >
    <div class="d-flex gap-2 flex-wrap">
      <v-tooltip v-if="mixedUse" location="bottom">
        <template #activator="{ props }">
          <PropertyTypeChip
            property-type="Mixed Use"
            class="wide-chip"
            v-bind="props"
          />
        </template>
        <span>Property Type</span>
      </v-tooltip>
      <v-tooltip v-if="type" location="bottom">
        <template #activator="{ props }">
          <PropertyTypeChip
            :property-type="type"
            class="wide-chip"
            v-bind="props"
          />
        </template>
        <span>Property Type</span>
      </v-tooltip>
      <v-tooltip v-if="buildingClass" location="bottom">
        <template #activator="{ props }">
          <CommonChip
            class="wide-chip text-white"
            color="black"
            v-bind="props"
          >
            {{ buildingClass }}
          </CommonChip>
        </template>
        <span>Building Class</span>
      </v-tooltip>
      <v-tooltip v-if="showTransactionStatus && transactionStatus" location="bottom">
        <template #activator="{ props }">
          <CommonChip
            class="wide-chip text-white"
            color="grey-darken-2"
            v-bind="props"
          >
            {{ transactionStatus }}
          </CommonChip>
        </template>
        <span>Transaction Status</span>
      </v-tooltip>
    </div>
    <div v-if="contractPending || leasePending" class="d-flex gap-2 flex-wrap">
      <AvailabilityTransactionStatusChip
        v-if="contractPending"
        status="In Escrow"
        class="wide-chip"
      />
      <CommonChip
        v-if="leasePending"
        status="Lease Pending"
        class="wide-chip text-white"
        color="#9CA88F"
      >
        Lease Pending
      </CommonChip>
    </div>
    <div v-if="status || inHouse || agencyType" class="d-flex gap-2" :class="{'flex-wrap': allowWrap}">
      <v-tooltip v-if="status" location="bottom">
        <template #activator="{ props }">
          <AvailabilityStatusChip
            :status="status"
            class="wide-chip"
            v-bind="props"
          />
        </template>
        <span>Status</span>
      </v-tooltip>
      <CommonChip
        v-if="inHouse"
        class="wide-chip text-white"
        color="green"
      >
        In House
      </CommonChip>
      <v-tooltip v-if="agencyType" location="bottom">
        <template #activator="{ props }">
          <CommonChip
            class="wide-chip text-white"
            :color="agencyType === 'Exclusive' ? 'green' : 'grey-darken-3'"
            v-bind="props"
          >
            {{ agencyType }}
          </CommonChip>
        </template>
        <span>Agency Type</span>
      </v-tooltip>
      <CommonChip
        v-if="isPublishedToWeb"
        color="green"
        class="wide-chip text-white"
      >
        <v-icon size="20" class="mr-1">mdi-web</v-icon>
        Published To Web
      </CommonChip>
    </div>
    <div v-if="isPortfolio">
      <CommonChip
        color="#A020F0"
        class="wide-chip text-white"
      >
        Portfolio
      </CommonChip>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import AvailabilityStatusChip from '@/bundles/Availabilities/components/AvailabilityStatusChip.vue';
import AvailabilityTransactionStatusChip from '@/bundles/Availabilities/components/AvailabilityTransactionStatusChip.vue';
import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';
import PropertyTypeChip from '@/components/properties/PropertyTypeChip.vue';

export default defineComponent({
  name: 'AvailabilityChipsWrapper',

  components: {
    CommonChip,
    AvailabilityStatusChip,
    PropertyTypeChip,
    AvailabilityTransactionStatusChip
  },

  props: {
    inHouse: Boolean,
    agencyType: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    vacancyType: {
      type: String,
      default: ''
    },
    buildingClass: {
      type: String,
      default: ''
    },
    transactionStatus: {
      type: String,
      default: ''
    },
    contractPending: Boolean,
    isPortfolio: Boolean,
    isOneLine: Boolean,
    mixedUse: Boolean,
    isPublishedToWeb: Boolean,
    allowWrap: Boolean,
    showTransactionStatus: Boolean,
    leasePending: Boolean,
  }
});
</script>

<style lang="scss">
.availabilities-chips-wrapper {
  height: 25px !important;
  background-color: transparent!important;
  .v-chip:hover {cursor: default!important;}
  .v-toolbar__content {
    height: 24px !important;
    padding: 4px 0!important;
  }
}
</style>
